<template>
  <div class="empty-box">
    <img src="@/assets/img/empty.png" class="icon-nodata">
    <div class="empty-text">{{message}}~</div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      default: '没有数据'
    }
  }
}
</script>

<style lang="less" scoped>
.empty-box {
  padding: 150px 0;
  display:flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  .icon-nodata {
    width: 200px;
    height: 200px;
    margin-bottom: 20px;
  }
  .empty-text {
    font-size: 24px;
    text-align: center;
    color: #999;
  }
}
</style>
